import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';

import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';

// https://laracasts.com/discuss/channels/livewire/roles242-uncaught-referenceerror-tomselect-is-not-defined?page=1&replyId=754316
import 'tom-select/dist/css/tom-select.bootstrap5.css';
window.TomSelect = require('tom-select');

import runtime from "serviceworker-webpack-plugin/lib/runtime";
if ("serviceWorker" in navigator) {
    runtime.register();
}

import app from './App.vue';
import router from './router';
import { createApp } from 'vue';
const vueApp = createApp(app);

import Console from './scripts/Console.js';
import Storage from './scripts/Storage.js';
import API from './scripts/API.js';
import Module from './scripts/Module.js';
import Application from './scripts/Application.js';

window.storage = new Storage();
window.storage.initialize().then(() => {
    window.application = new Application({
        storage: window.storage,
        api: new API(),
        module: new Module(),
        console: new Console(),
    });

    window.application.initialize().then(() => {
        console.log('main.js.initialized');
        vueApp.config.globalProperties.app = window.application;
        vueApp
            .use(router, vueApp)
            .mount('#app')
    }).catch(error => {
        console.error(error || 'Error');
        var el1 = document.getElementById('app_start_title');
        var el2 = document.getElementById('app_start_description');
        if( el1 ) el1.innerText = 'The application cannot start...';
        if( el2 ) el2.innerHTML = 'The app requires an initial connection to the server.<br>Please connect to the internet and try again.';
    });
}).catch(error => {
    console.error(error || 'Error');
    var el1 = document.getElementById('app_start_title');
    var el2 = document.getElementById('app_start_description');
    if( el1 ) el1.innerText = 'The application cannot start...';
    if( el2 ) el2.innerHTML = 'The app could not create a local database. Please contact support.';
});